import routes from '@modules/stripe/stripe-balance/stripe-balance-routes';
import store from '@modules/stripe/stripe-balance/stripe-balance-store';

export default {
  routes,
  store,
};
